// extracted by mini-css-extract-plugin
export default {"tabMenu":"TabQna_tabMenu__T15+6","active":"TabQna_active__Pq75l"};